module.exports = __webpack_public_path__ + "static/Muli-Light-bc4db201874922a361665ec937b5db53.woff2";